import {
  SET_QR_TEMPLATE,
  GENERATE_QR_CODE,
  SET_QR_CODE_STATE,
  SET_QR_OBJECTIVES_DATA,
} from "../types";

const initialState = {
  data: {},
  qrCodeImgSrc: "",
  objectivesData: {},
  currTemplateData: {},
};

const qrCodeReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_QR_CODE_STATE:
      return {
        ...state,
        data: action.payload,
      };
    case GENERATE_QR_CODE:
      return {
        ...state,
        qrCodeImgSrc: action.payload,
      };
    case SET_QR_TEMPLATE:
      return {
        ...state,
        currTemplateData: action.payload,
      };
    case SET_QR_OBJECTIVES_DATA:
      return {
        ...state,
        objectivesData: action.payload,
      };
    default:
      return state;
  }
};

export default qrCodeReducer;
